import { call, select } from 'redux-saga/effects'
import { optimisticPut } from 'utils/sagas'
import { action as apiAction } from 'api/Api'
import sweetalert from 'sweetalert2'
import {
  setProfileByProfileKey
} from '../redux/users'

export default function * requestChangeCurrentUserProfile (action) {
  const fields = action.payload

  const state = yield select()

  const id = state.kanbo.currentUser.id
  const profileKey = state.kanbo.currentUser.profileKey

  const currentProfile = state.kanbo.users[id].profile
  const currentFields = currentProfile.fields

  const newFields = {
    ...currentFields,
    ...fields
  }

  const optimisticAction = yield optimisticPut(setProfileByProfileKey({
    profileKey,
    profile: {
      ...currentProfile,
      fields: newFields
    }
  }))

  try {
    yield call(apiAction, 'ChangeMyProfile', {
      profile: newFields
    })

    yield optimisticAction.commit()
  } catch (error) {
    yield optimisticAction.revert()

    if (error.code === 300) {
      const state = yield select()

      try {
        yield call(sweetalert, {
          type: 'error',
          text: state.kanbo.locale.messages['USER_EMAIL_IN_USE']
        })
      } catch (e) {}
    } else {
      throw error
    }
  }
}
